module.exports = __webpack_public_path__ + "static/redAudio.eda19fe9.svg";